(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.constants = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  _exports.__esModule = true;
  _exports.rootKey = _exports.rootConfigKey = _exports.pausing = _exports.keyName = void 0;
  var keyName = "wx";
  _exports.keyName = keyName;
  var rootKey = "$root";
  _exports.rootKey = rootKey;
  var rootConfigKey = "_vuewx";
  _exports.rootConfigKey = rootConfigKey;
  var pausing = "pausing";
  _exports.pausing = pausing;
});
//# sourceMappingURL=constants.js.map